import { Amplify, Logger } from 'aws-amplify';
import setupAWSCredentials from './setupAWSCredentials'
const logger = new Logger('Lambda Execution', 'INFO');

async function execute( lambdaName,payload, retried=false ){

	let params = {
		FunctionName: lambdaName, 
		InvocationType: "RequestResponse",
		Payload: JSON.stringify(payload), 
	};
	const lambda = new AWS.Lambda({
		apiVersion: '2015-03-31',
		region: 'us-east-1'
	});

	try{
		logger.debug('ejecutando lambda', lambdaName);
		let {StatusCode, Payload} = await lambda.invoke(params).promise();
		logger.debug('ejecucion lambda finalizada: ', lambdaName, StatusCode, Payload);
		
		if( StatusCode !== 200 )	throw Payload;

		let response = typeof Payload === 'string'? JSON.parse(Payload):Payload;

		if( response.error !== null )	throw response.error;

		return typeof response.body === 'string'? JSON.parse(response.body):response.body;
	}catch(err){

		if( retried !== true && err instanceof Error ){

			if(err.code === 'ConfigError'){
				logger.debug('error de configuracion. Intentando configurar...')
				let resp = await setupAWSCredentials();
				return await execute( lambdaName,payload, true )
			}else{
				logger.debug('credenciales expiradas. Intentando re-configurar...')
				await setupAWSCredentials();
				return await execute( lambdaName,payload, true )
			}
		}

		logger.error('error al ejecutar lambda:', lambdaName, err);
		throw err;
	}
}

export default execute;